import PropTypes from 'prop-types';

import { resolveRichTextHtml } from '../../../helpers/richTextHtml';

const SectionTextBody = ({ text }) => {
  if (!text) {
    return null;
  }

  if (/<[a-z][\s\S]*>/i.test(text)) {
    return (
      <div
        className="unitatsespecialitzades-description"
        dangerouslySetInnerHTML={{ __html: resolveRichTextHtml(text) }}
      />
    );
  }

  return <p className="unitatsespecialitzades-description">{text}</p>;
};

SectionTextBody.propTypes = {
  text: PropTypes.string,
};

export default SectionTextBody;
